import { render, staticRenderFns } from "./transitionTrend.vue?vue&type=template&id=2fd8ab12&scoped=true&"
import script from "./transitionTrend.vue?vue&type=script&lang=js&"
export * from "./transitionTrend.vue?vue&type=script&lang=js&"
import style0 from "./transitionTrend.vue?vue&type=style&index=0&id=2fd8ab12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8ab12",
  null
  
)

export default component.exports